import record from '@/api/dashbaord'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  totalDealer(context, attrubutes = {}) {
		return record.totalDealer({ params: {
				...attrubutes
    }})
  },
  betting(context, attrubutes = {}) {
		return record.betting({ params: {
				...attrubutes
    }})
  },
  balance(context, attrubutes = {}) {
		return record.balance({ params: {
				...attrubutes
    }})
  }
}
